import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { FaCheck } from "react-icons/fa";
import { IoMdArrowDropup, IoMdArrowDropdown } from "react-icons/io";
import { Services } from "../../../services/Services";

import { setGuidePosition } from "../../../redux/actions";

const ByCountry = ({
  language,
  countries,
  visible,
  toggle,
  guidePosition,
  setGuidePosition,
}) => {
  const [activeItem, setActiveItem] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [results, setResults] = useState([]);
  const [added, setAdded] = useState([]);

  useEffect(() => {
    if (countries.length) setActiveItem(countries[0]);
  }, [countries]);

  useEffect(() => {
    setActiveItem(countries[currentIndex]);
  }, [countries, currentIndex]);

  const fetchChannels = useCallback(() => {
    Services.searchInternetChannels({ country_id: activeItem.id }).then(
      (res) => {
        setResults(res.data.channels);
        setAdded(res.data.selected_channels_ids);
      }
    );
  }, [activeItem]);

  useEffect(() => {
    if (activeItem) fetchChannels();
  }, [activeItem, fetchChannels]);

  const slideUp = (e) => {
    e.stopPropagation();
    if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
    else setCurrentIndex(countries.length - 1);
  };

  const slideDown = (e) => {
    e.stopPropagation();
    if (currentIndex < countries.length - 1) setCurrentIndex(currentIndex + 1);
    else setCurrentIndex(0);
  };

  const handleClick = (item, index) => {
    setActiveItem(item);
    setCurrentIndex(index);
    // toggle(!visible);
    if (guidePosition === 5) {
      setGuidePosition(6);
    }
  };

  const toggleClick = (id) => {
    let params = { channels_ids: [id] };
    if (added.includes(id))
      Services.internetChannelsRemove(params).then(() => fetchChannels());
    else Services.internetChannelsAdd(params).then(() => fetchChannels());
  };

  const addChannel = (id) => {
    let params = { channels_ids: [id] };
    if (!added.includes(id))
      Services.internetChannelsAdd(params).then(() => fetchChannels());
  };

  const deactiveGuideTootltips = () => {
    setGuidePosition(0);
    localStorage.setItem("showed_internettv_info", true);
  };

  return (
    <>
      <label>{language.search_by_country_label}</label>
      <div className="select scroll">
        <div onClick={() => toggle(!visible)} className="top">
          {activeItem && activeItem.name}
          <div className="arrows">
            <IoMdArrowDropup onClick={slideUp} />
            <IoMdArrowDropdown onClick={slideDown} />
          </div>
        </div>
        {visible ? (
          <div className="options">
            {countries.length
              ? countries.map((item, index) => (
                  <p
                    key={index}
                    onClick={() => handleClick(item, index)}
                    className={item.id === activeItem.id ? "active" : ""}
                  >
                    {item.name}
                  </p>
                ))
              : null}
          </div>
        ) : null}
      </div>
      <div className="byName_items">
        {results.length ? (
          results.map((item, index) => (
            <div className="item" key={item.id}>
              <div
                className="img"
                style={{ background: `url(${item.stream_icon})` }}
              />
              <p title={item.name}>
                {item.name.length > 20
                  ? item.name.substring(0, 20) + "..."
                  : item.name}
              </p>

              <div className="checkbox" onClick={() => toggleClick(item.id)}>
                {added.find((el) => el === item.id) ? <FaCheck /> : null}
                {index === 0 && guidePosition === 6 ? (
                  <div className="tooltip third">
                    <div className="triangle"></div>
                    <p>
                      {
                        language.guide.internet_channels.add_channels
                          .select_channel_info
                      }
                    </p>
                    <div className="buttons">
                      <button
                        className="skip"
                        onClick={() => deactiveGuideTootltips()}
                      >
                        {language.guide.internet_channels.skip_btn}
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          addChannel(item.id);
                          setGuidePosition(7);
                        }}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          ))
        ) : (
          <p>No Result!</p>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    countries: state.countries,
    guidePosition: state.guidePosition,
    language: state.selectedLanguage,
  };
};

const mapDispatchToProps = { setGuidePosition };

export default connect(mapStateToProps, mapDispatchToProps)(ByCountry);
